import { render, staticRenderFns } from "./content-vimeo-video.vue?vue&type=template&id=ddbeab92&scoped=true"
import script from "./content-vimeo-video.vue?vue&type=script&lang=js"
export * from "./content-vimeo-video.vue?vue&type=script&lang=js"
import style0 from "./content-vimeo-video.vue?vue&type=style&index=0&id=ddbeab92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbeab92",
  null
  
)

export default component.exports